import { errorFromResponse, normalizeApiError } from "./apiErrors";

export const DEFAULT_PRODUCTION_API_BASE_URL =
  "https://strato-quote-backend-production.stratolab3d.workers.dev";

export function getApiBaseUrl() {
  const baseUrl = normalizeApiBaseUrl(
    process.env.REACT_APP_STRATO_API_BASE_URL ||
      DEFAULT_PRODUCTION_API_BASE_URL,
  );

  if (
    process.env.REACT_APP_STRATO_ENV === "production" &&
    baseUrl.includes("-preview.")
  ) {
    throw new Error("Production build cannot use the preview Strato API.");
  }

  return baseUrl;
}

function normalizeApiBaseUrl(value) {
  const baseUrl = String(value || "").trim();

  if (!baseUrl) {
    throw new Error("Strato API base URL is empty.");
  }

  if (/[()[\]]/.test(baseUrl)) {
    throw new Error(
      "Invalid Strato API base URL. Use a plain https URL, not a Markdown link.",
    );
  }

  let parsedUrl;
  try {
    parsedUrl = new URL(baseUrl);
  } catch {
    throw new Error("Invalid Strato API base URL. Use a valid https URL.");
  }

  if (!["http:", "https:"].includes(parsedUrl.protocol)) {
    throw new Error("Invalid Strato API base URL. Use http or https.");
  }

  return baseUrl.replace(/\/+$/, "");
}

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalizedPath}`;
}

export async function requestJson(path, { method = "POST", body, headers = {}, timeoutMs = 20000 } = {}) {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(buildApiUrl(path), {
      method,
      headers: {
        "content-type": "application/json",
        "x-strato-intake-version": "react-v1-preview",
        ...headers,
      },
      body: body === undefined ? undefined : JSON.stringify(body),
      signal: controller.signal,
    });

    if (!response.ok) {
      throw await errorFromResponse(response);
    }

    return await response.json();
  } catch (error) {
    throw normalizeApiError(error);
  } finally {
    window.clearTimeout(timeout);
  }
}
